import React, { useRef } from "react";
import type { LucideIcon } from "lucide-react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";

interface ImportTabPanelProps {
  title: string;
  description: string;
  icon: LucideIcon;
  loading: boolean;
  accept?: string;
  buttonLabel?: string;
  multiple?: boolean;
  onFileSelect: (
    e: React.ChangeEvent<HTMLInputElement>,
    fileInputRef?: React.RefObject<HTMLInputElement | null>,
  ) => void;
}

export const ImportTabPanel = ({
  title,
  description,
  icon: Icon,
  loading,
  accept = ".csv",
  buttonLabel = "Select CSV file",
  multiple = false,
  onFileSelect,
}: ImportTabPanelProps) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleSelectClick = () => {
    fileInputRef.current?.click();
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onFileSelect(e, fileInputRef);
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="border-2 border-dashed rounded-lg p-8 flex flex-col items-center justify-center bg-muted/20">
          <Icon className="h-10 w-10 text-muted-foreground mb-4" />
          <Button
            variant="secondary"
            disabled={loading}
            onClick={handleSelectClick}
            className="cursor-pointer"
          >
            {buttonLabel}
          </Button>
          <input
            type="file"
            accept={accept}
            multiple={multiple}
            className="hidden"
            ref={fileInputRef}
            onChange={handleChange}
          />
        </div>
      </CardContent>
    </Card>
  );
};
